<template>
    <b-row style="margin: 0">
        <b-col
            id="bg-photo"
            class="d-none d-sm-block"
            md="5"
            :style="{
                background: 'url(/images/enterprise_login_image.jpeg) no-repeat left',
                height: '100vh',
                color: 'white',
                backgroundSize: 'cover',
                WebkitBackgroundSize: 'cover',
                MozBackgroundSize: 'cover',
                OBackgroundSize: 'cover',
            }"
        >
        </b-col>

        <b-col style="padding-left: 0; padding-right: 0" sm="12" md="7">
            <b-container class="mt-3">
                <b-row class="back-link-wrapper">
                    <b-col class="d-flex">
                        <button class="back-link" @click="goBack()"><ArrowLeft /></button>
                        <div class="d-md-none d-lg-none" style="flex-grow: 1; text-align: center; margin-right: 16px">
                            <img src="/images/logo/mobile-logo.png" height="30px" alt="logo" />
                        </div>
                    </b-col>
                </b-row>

                <img
                    class="d-none d-md-block mt-5 mb-4 mx-auto"
                    src="/images/logo/infusion.svg"
                    alt="TalentInfusion"
                    title="TalentInfusion"
                />

                <b-row class="justify-content-center m-0">
                    <h6 class="step-title">Sign Up</h6>
                </b-row>

                <b-row class="mt-0 justify-content-md-center">
                    <b-col sm="10" lg="6">
                        <div>
                            <button
                                class="w-100 d-flex align-items-center justify-content-center btn-google-login"
                                @click="signUpWithGoogle"
                            >
                                <img src="/images/google.svg" width="38" height="36" alt="Google" title="Google" />
                                <span style="flex-grow: 1">Sign up with Google</span>
                            </button>
                        </div>
                        <OrDivider />
                    </b-col>
                </b-row>

                <b-row class="mt-0 justify-content-md-center">
                    <b-col sm="10" lg="6">
                        <form class="w-100" @submit.prevent="submit">
                            <text-field
                                id="first_name"
                                v-model="user.first_name"
                                :error-messages="errorMessages.first_name"
                                :messages="messages.first_name"
                                label="First Name"
                                placeholder="Your first name"
                                type="text"
                                class="mb-3"
                                required
                                :disabled="isTeamMemberSignup"
                                @input="validateFirstName"
                            />
                            <text-field
                                id="last_name"
                                v-model="user.last_name"
                                :error-messages="errorMessages.last_name"
                                :messages="messages.last_name"
                                label="Last Name"
                                placeholder="Your last name"
                                type="text"
                                class="mb-3"
                                required
                                :disabled="isTeamMemberSignup"
                                @input="validateLastName"
                            />
                            <text-field
                                id="email"
                                v-model="user.email"
                                :error-messages="errorMessages.email"
                                :messages="messages.email"
                                label="Work E-mail"
                                placeholder="you@yourcompany.com"
                                type="email"
                                class="mb-3"
                                required
                                :disabled="isTeamMemberSignup"
                                @input="validateEmail"
                            />
                            <text-field
                                id="password"
                                v-model="user.password"
                                :error-messages="errorMessages.password"
                                :messages="messages.password"
                                label="Create Your Password"
                                placeholder="Enter your password"
                                type="password"
                                class="mb-5"
                                required
                                @input="validatePassword"
                            />
                            <div>
                                <styled-button
                                    class="w-100 mb-2 text-dark"
                                    type="submit"
                                    :has-action="loading"
                                    :disabled="hasError || loading"
                                >
                                    Continue
                                </styled-button>
                                <div class="auth-signup__info">
                                    <p style="font-size: 12px; text-align: center" class="body-2">
                                        By Signing up to Talent Infusion, I Accepted the
                                        <a
                                            href="https://talentinfusion.io/terms-of-service/"
                                            target="_bland"
                                            rel="noopener"
                                            ><strong>Terms and Conditions</strong></a
                                        >.
                                    </p>

                                    <router-link :to="{ name: $routes.EMPLOYER_SIGNIN.name }">
                                        <button type="button" class="w-100 alreadyAccountBtn">
                                            Have an account? Sign In
                                        </button>
                                    </router-link>
                                </div>
                            </div>
                        </form>
                    </b-col>
                </b-row>
            </b-container>
        </b-col>
    </b-row>
</template>

<script>
import isEmail from 'validator/es/lib/isEmail';
import { googleSdkLoaded } from 'vue3-google-login';
import { mapActions } from 'vuex';

import { AUTH } from '@/api/endpoints';
import OrDivider from '@/components/Divider/OrDivider.vue';
import ArrowLeft from '@/components/Icon/ArrowLeft.vue';
import StyledButton from '@/components/StyledButton.vue';
import TextField from '@/components/TextField.vue';
import { SUBSCRIPTION_STATUS } from '@/constants/subscriptions';
import { UserType } from '@/constants/user';
import { ACCOUNT_DASHBOARD, EMPLOYER_SIGNIN, ENTERPRISE_ONBOARDING_ACCOUNT, VERIFICATION_CODE } from '@/router/routes';
import { activeNamespaces } from '@/store';

export default {
    name: 'OnboardingSignup',
    components: {
        TextField,
        StyledButton,
        ArrowLeft,
        OrDivider,
    },

    data() {
        return {
            loading: false,
            isTeamMemberSignup: false,
            user: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
            },
            errorMessages: {
                first_name: [],
                last_name: [],
                email: [],
                password: [],
            },
            messages: {
                first_name: [],
                last_name: [],
                email: [],
                password: [],
            },
            success: false,
        };
    },
    computed: {
        hasError() {
            return (
                this.errorMessages.first_name.length > 0 ||
                this.errorMessages.last_name.length > 0 ||
                this.errorMessages.email.length > 0 ||
                this.errorMessages.password.length > 0
            );
        },
    },

    created() {
        this.price = this.$route.query.price;
        this.isInvited = this.$route.query.is_invited;
        const inviteData = this.$route.query?.invite_data;
        this.fetchDecodedInviteData(inviteData);
        if (this.$route.query.payment === 'success') {
            this.success = true;
        }
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },

    methods: {
        ...mapActions(activeNamespaces.app, {
            setToken: 'SET_TOKEN',
            setUser: 'SET_USER',
        }),
        handleScroll() {
            const bgPhoto = document.getElementById('bg-photo');
            if (bgPhoto) {
                bgPhoto.style.marginTop = `${window.scrollY}px`;
            }
        },
        fetchDecodedInviteData(inviteData) {
            if (inviteData) {
                this.$api
                    .get(AUTH.DECODE_JWT(inviteData))
                    .then(({ data }) => {
                        this.user.first_name = data.first_name;
                        this.user.last_name = data.last_name;
                        this.user.email = data.email;
                        this.isTeamMemberSignup = true;
                    })
                    .catch((err) => {
                        const { message } = err;
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Oops',
                            text: message,
                        });
                    });
            }
        },
        validateFirstName() {
            this.errorMessages.first_name = [];
            this.messages.first_name = [];

            if (!this.user.first_name) {
                this.errorMessages.first_name = ['First name is required'];
            }
        },
        validateLastName() {
            this.errorMessages.last_name = [];
            this.messages.last_name = [];

            if (!this.user.last_name) {
                this.errorMessages.last_name = ['Last name is required'];
            }
        },
        validateEmail() {
            this.errorMessages.email = [];
            this.messages.email = [];

            if (isEmail(this.user.email)) {
                this.errorMessages.email = [];
            } else if (!this.user.email) {
                this.errorMessages.email = ['Email address is required'];
            } else {
                this.errorMessages.email = ['Invalid Email address'];
            }
        },
        sendCode() {
            this.resending = true;
            this.$api
                .post(AUTH.SEND_CODE(), { email: this.user.email })
                .then(({ data }) => {
                    const { success } = data;
                    this.success = success;
                    this.resending = false;
                    this.$router.push({
                        name: VERIFICATION_CODE.name,
                        query: {
                            email: this.user.email,
                            condition: 'new_user',
                            price: this.price,
                        },
                    });
                })
                .catch(({ request, response }) => {
                    this.resending = false;
                    if (response) {
                        const { data } = response;
                        const { message } = data;
                        this.error = message;
                    } else if (request) {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Oops',
                            text: 'Something went wrong on the api side.',
                        });
                    } else {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Oops',
                            text: 'Something went wrong when calling the api.',
                        });
                    }
                });
        },
        validatePassword() {
            this.errorMessages.password = [];
            this.messages.password = [];

            if (!this.user.password) {
                this.errorMessages.password = ['Password is required'];
            } else if (this.user.password.length < 8) {
                this.errorMessages.password = ['Your password is too short'];
                this.messages.password = ['Your password should be 8 characters long'];
            }
        },
        async signUpWithGoogle() {
            this.loading = true;

            googleSdkLoaded((google) => {
                google.accounts.oauth2
                    .initCodeClient({
                        client_id: process.env.VUE_APP_CLIENT_ID,
                        scope: 'email profile openid',
                        callback: (googleResponse) => {
                            if (googleResponse.code) {
                                try {
                                    const referral = this.$route.query?.referral;
                                    this.$api
                                        .post(AUTH.GOOGLE_SIGNUP(), {
                                            idToken: googleResponse.code,
                                            referral,
                                        })
                                        .then(async ({ data }) => {
                                            const { success } = data;
                                            if (success === false) {
                                                const { message } = data;
                                                this.$notify({
                                                    group: 'foo',
                                                    type: 'error',
                                                    title: 'Google Signup',
                                                    text: message,
                                                });
                                            } else {
                                                const { token, user } = data;
                                                localStorage.setItem('tiAccessToken', token);
                                                this.setToken(token);
                                                this.setUser(user);

                                                try {
                                                    if (
                                                        user.user_type === UserType.MEMBER ||
                                                        data.subscription?.status === SUBSCRIPTION_STATUS.ACTIVE
                                                    ) {
                                                        this.success = true;
                                                        this.$router.push({ name: ACCOUNT_DASHBOARD.name });
                                                    } else {
                                                        this.$router.push({
                                                            name: ENTERPRISE_ONBOARDING_ACCOUNT.name,
                                                            query: {
                                                                price: this.price,
                                                            },
                                                        });
                                                    }

                                                    // this.success = true
                                                } catch (err) {
                                                    this.$router.push({
                                                        name: EMPLOYER_SIGNIN.name,
                                                        query: {
                                                            checkout: false,
                                                        },
                                                    });
                                                }
                                            }
                                        })
                                        .catch(({ request, response }) => {
                                            this.success = false;
                                            if (response) {
                                                const { data } = response;
                                                const { message } = data;

                                                this.$notify({
                                                    group: 'foo',
                                                    type: 'error',
                                                    title: 'Google Signup',
                                                    text: message,
                                                });
                                            } else if (request) {
                                                this.$notify({
                                                    group: 'foo',
                                                    type: 'error',
                                                    title: 'Oops',
                                                    text: 'Something went wrong on the api side.',
                                                });
                                            } else {
                                                this.$notify({
                                                    group: 'foo',
                                                    type: 'error',
                                                    title: 'Oops',
                                                    text: 'Something went wrong when calling the api.',
                                                });
                                            }
                                        })
                                        .finally(() => {
                                            this.loading = false;
                                        });
                                } catch (error) {
                                    this.$console.error(error);
                                }
                            }
                        },
                    })
                    .requestCode();
            });

            this.loading = false;
        },
        submit() {
            this.loading = true;
            const referral = this.$route.query?.referral;
            this.$api
                .post(AUTH.REGISTER_EMPLOYER(), {
                    referral,
                    ...this.user,
                })
                .then(async () => {
                    try {
                        this.sendCode();
                    } catch (err) {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Oops',
                            text: 'Something went wrong on the api side.',
                        });
                    }
                })
                .catch((error) => {
                    this.success = false;

                    if (error.response) {
                        const { data } = error.response;
                        const { message } = data;

                        this.errorMessages.email = [message];
                    } else if (error.request) {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Oops',
                            text: 'Something went wrong on the api side.',
                        });
                    } else {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'Oops',
                            text: 'Something went wrong when calling the api.',
                        });
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        goBack() {
            window.history.back();
        },
    },
};
</script>

<style lang="scss" scoped>
.back-link-wrapper {
    padding: 16px;

    .back-link {
        color: #121212;
    }

    @media screen and (max-width: 768px) {
        margin-bottom: 8px;
    }
}

.step-title {
    color: #000;
    font-family: Inter;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 30px;
}

.alreadyAccountBtn {
    font-weight: 500;
    font-size: 14px;
    border: solid 1px #ffac2f;
    border-radius: 4px;
    color: #121212;
    padding: 8px 12px;
}

.btn-google-login {
    span {
        font-size: 14px;
        font-weight: 600;
        text-align: center;
    }
}

::v-deep .or-text {
    font-size: 14px;
    font-weight: 600;
}
</style>
